var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-6 0 63 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M451,471a5.005,5.005,0,0,1-5-5V428a5.006,5.006,0,0,1,5-5h21.07a.9.9,0,0,1,.489.138.876.876,0,0,1,.219.157l8.908,8.977a1,1,0,0,1,.314.7c0,.008,0,.017,0,.025v33a5.006,5.006,0,0,1-5,5Zm-3-43v38a3,3,0,0,0,3,3h26a3,3,0,0,0,3-3V433h-4a3.626,3.626,0,0,1-4-4v-4H451A3,3,0,0,0,448,428Zm25,1a3,3,0,0,0,3,3h3l-6-6Zm-20,32a1,1,0,1,1,0-2h12a1,1,0,0,1,0,2Zm0-7a1,1,0,1,1,0-2h22a1,1,0,1,1,0,2Zm0-7a1,1,0,1,1,0-2h22a1,1,0,1,1,0,2Zm0-7a1,1,0,0,1,0-2h22a1,1,0,0,1,0,2Z",
    transform: "translate(-446 -423)",
    fill: "#08a2aa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDocument);
export default __webpack_public_path__ + "static/media/ico-document.8f91ba36.svg";
export { ForwardRef as ReactComponent };